module.exports = __webpack_public_path__ + "static/media/personal-data.935f0640.svg";